module.exports = __webpack_public_path__ + "static/media/G1-27-Maya-Myron-cod58.6879a45b.png";